module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/deodorant@2x_aae5cd.png";